import Vue from "vue";
import {urlGenerator} from "./AxiosHelper";

export const editAction = (permission, url= null) => ({
    title: Vue.prototype.$t('edit'),
    key: "edit",
    name: "edit",
    url: urlGenerator(url),
    icon: 'edit',
    modifier: row => permission,
})

export const deleteAction = (permission, url= null) => ({
    title: Vue.prototype.$t('delete'),
    key: "delete",
    name: "delete",
    url: urlGenerator(url),
    icon: 'trash',
    modifier: row => permission,
})